class Contact {
	id = null;
	vtiger_id = null;
	first_name = '';
	last_name = '';
	email = '';
	descriptions = [];
	partner_id = null;

	constructor(data) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}
	}
}

export default Contact;
